module.exports = __webpack_public_path__ + "img/Awards_Back.e369094b.png";